<template>
  <v-list-item
    :to="item.to"
    class="px-0 primary--text"
  >
    <v-list-item-icon>
      <v-icon v-text="item.icon"></v-icon>
    </v-list-item-icon>

    <v-list-item-content>
      <v-list-item-title v-text="item.title" />
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: "SidebarBaseItem",

  props: {
    item: {
      type: Object,
      default: () => ({
        icon: null,
        title: null,
        to: null
      })
    },
  },
};
</script>
